import { createDialogContextBundle } from "src/components/Dialog";
import { BulkDuplicateDialogProps } from "./types";

export const {
  DialogContext: BulkDuplicateDialogContext,
  useDialogContext: useBulkDuplicateDialogContext,
} = createDialogContextBundle<BulkDuplicateDialogProps>();
